import React from "react";
import InfoRow from "src/components/InfoRow";
import { Separator } from "src/components/ui/separator";
import CustomDataTable from "src/components/CustomDataTable";
import { cn, getCustomizationValue } from "src/lib/utils";
import { useAuth } from "src/providers/AuthProvider";

const columns = [
	{ name: "Items", selector: (row) => "BMW Engine part" },
	{ name: "Price", selector: (row) => "N3,000.00" },
	{ name: "Qty", selector: (row) => "20", maxWidth: "100px" },
	{ name: "Total", selector: (row) => "N 600,000.00" },
];

const SettlementDetails = () => {
	const { user } = useAuth();

	return (
		<div className="pageWrapper">
			<div className="pageTop">
				<h2 className="tw-text-[22px] tw-font-semibold">
					Settlements {">"} Outstanding Balance {">"} James & Sons ltd
				</h2>
			</div>

			<div className="innerContent">
				<h2 className="tw-text-primary tw-text-[20px] tw-font-semibold tw-mb-5">James & Sons Ltd</h2>
				<div className="tw-bg-white tw-shadow-[0_0_5px_rgba(0,0,0,0.2)] tw-px-12 tw-py-8 tw-rounded-3xl tw-grid tw-gap-7">
					<div className="tw-flex tw-items-center tw-justify-between">
						<p className="tw-text-primary tw-font-semibold tw-text-[18px]">Billed to</p>
						<div className="tw-flex tw-items-center tw-gap-4">
							<span className="tw-bg-[#FF980033] tw-px-4 tw-text-[15px] tw-font-medium tw-py-1.5 tw-rounded-full tw-text-[#FF9800]">
								Outstanding
							</span>
							<span className="tw-bg-red-700 tw-px-4 tw-text-[15px] tw-font-medium tw-py-1.5 tw-rounded-full tw-text-white">
								Send Reminder
							</span>
						</div>
					</div>
					<div className="tw-flex tw-items-center tw-justify-between">
						<div>
							<InfoRow title="Customer Name:">James & Sons Ltd</InfoRow>
							<InfoRow title="Customer Email:">James & Sons Ltd</InfoRow>
							<InfoRow title="Customer Phone Number:">James & Sons Ltd</InfoRow>
							<InfoRow title="Customer BVN:">James & Sons Ltd</InfoRow>
							<InfoRow title="Customer Address:">James & Sons Ltd</InfoRow>
						</div>
						<div>
							<InfoRow title="Business Name">James & Sons Ltd</InfoRow>
							<InfoRow title="Due Date:">12 October, 2024</InfoRow>
							<InfoRow title={cn(getCustomizationValue(user, "invoice_label", true), " number:")}>INV001</InfoRow>
						</div>
					</div>
					<Separator className="tw-my-3 tw-bg-[#33333326]" />
					<InfoRow title="Payment Option:" containerClassName="tw-max-w-[300px]">
						Cash
					</InfoRow>
					<Separator className="tw-my-3 tw-bg-[#33333326]" />
					<div>
						<p className="tw-text-primary tw-font-semibold tw-text-[18px] tw-mb-3">Item Details</p>
						<CustomDataTable data={Array(4).fill("")} columns={columns} containerClassName="!tw-shadow-none" />
					</div>
					<Separator className="tw-my-3 tw-bg-[#33333326]" />
					<div>
						<p className="tw-text-primary tw-font-semibold tw-text-[18px] tw-mb-3">Summary</p>
						<InfoRow title="Subtotal:">N2,000,000.00</InfoRow>
						<InfoRow title="Discount:">N100,000.00</InfoRow>
						<InfoRow title="VAT:">N100,000.00</InfoRow>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SettlementDetails;
